import { CurrencyEnum } from '../interfaces/plan.interface';
import { postalCodeFormatMap } from '../config/countries';
import { getCurrencyForCountry } from '../config/currencies';

/**
 * Get currency enum from country name
 * @param countryName - Full country name (e.g., "United States", "Germany")
 * @returns CurrencyEnum for the country
 */
export const getCurrencyFromCountry = (countryName: string): CurrencyEnum => {
  if (!countryName) {
    return CurrencyEnum.USD;
  }
  
  const countryCode = postalCodeFormatMap[countryName]?.code;
  if (!countryCode) {
    return CurrencyEnum.USD;
  }
  
  return getCurrencyForCountry(countryCode) || CurrencyEnum.USD;
};

/**
 * Get currency symbol from country name
 * @param countryName - Full country name
 * @returns Currency symbol (e.g., "$", "€", "£")
 */
export const getCurrencySymbolFromCountry = (countryName: string): string => {
  const currency = getCurrencyFromCountry(countryName);
  const currencyConfig = {
    [CurrencyEnum.USD]: '$',
    [CurrencyEnum.EUR]: '€',
    [CurrencyEnum.GBP]: '£',
  };
  
  return currencyConfig[currency] || '$';
};

/**
 * Validate if a currency is supported
 * @param currency - Currency enum to validate
 * @returns boolean indicating if currency is supported
 */
export const isCurrencySupported = (currency: CurrencyEnum): boolean => {
  return Object.values(CurrencyEnum).includes(currency);
}; 